import { useTranslate } from '@tolgee/react';
import { useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import JoinRefereeForm, { JoinRefereeFormData } from 'components/join/JoinRefereeForm';

const defaultValues: JoinRefereeFormData = {
  name: '',
  email: '',
  phone: '',
  foreign: false,
  experience: '',
  identification: '',
};

interface JoinRefereeSendProps {}

function JoinRefereeSend({}: JoinRefereeSendProps) {
  const { t } = useTranslate('general');
  const [error, setError] = useState<Error | undefined>(undefined);
  const [success, setSuccess] = useState(false);

  const send = async (data: JoinRefereeFormData) => {
    setError(undefined);
    setSuccess(false);

    const response = await fetch('/api/join/referee', {
      body: JSON.stringify({ union: process.env.NEXT_PUBLIC_UNION, ...data }),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    });

    const result = (await response.json()) as {
      success?: boolean;
      error?: string;
    };

    if (result.error) {
      setError(new Error(result.error));
      return;
    }

    if (result.success) {
      setSuccess(true);
    }
  };

  if (success) {
    return (
      <div className='Form Form--center'>
        <h2>{t('join.referee.form.success.title')}</h2>
        <p className='Form__message'>{t('join.referee.form.success.message')}</p>
      </div>
    );
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}>
      {error && <p>{error}</p>}
      <JoinRefereeForm onSubmit={send} values={defaultValues} />
    </GoogleReCaptchaProvider>
  );
}

export default JoinRefereeSend;
